import { ServiceType } from './';
import { State } from './state';

export class SupplierMarketSetting {
	public id: number;
	public supplierId: string;
	public stateId: string;
	public serviceTypeId: string;
	public utilityId: string;
	public isLoaRequiredForPricingSession: boolean;
	public isBillRequiredForEnrollment: boolean;

	public state: State;
	public serviceType: ServiceType;
	public utility: any;

	constructor(supplierMarketSetting?: Partial<SupplierMarketSetting>) {
		Object.assign(this, supplierMarketSetting);
	}
}
